import { CompanyType, PeoInfoFragment, PeoUpdate } from 'src/api';

import { FormValues } from '../types';

export const buildUpdateFnInput = (
  formValues: FormValues,
  peo: PeoInfoFragment,
): Omit<PeoUpdate, 'id'> => {
  const baseInput: Omit<PeoUpdate, 'id'> = {
    // Reset on going standalone, so a stale flag does not re-enable payout on a later placement.
    keepOwnRevenueShare:
      formValues.controlledBy === CompanyType.PeoPayrollProvider && formValues.keepOwnRevenueShare,
  };

  if (formValues.controlledBy === CompanyType.Peo) {
    if (peo.peoPayrollProvider) {
      baseInput.peoPayrollProvider = {
        disconnect: { id: peo.peoPayrollProvider.id },
      };
    }
  }

  if (formValues.controlledBy === CompanyType.PeoPayrollProvider && formValues.peoPayrollProvider) {
    baseInput.peoPayrollProvider = {
      connect: { id: formValues.peoPayrollProvider.id },
    };
  }

  return baseInput;
};
